import styles from './ClientPersonalDetails.module.scss';

import moment from 'moment';
import CheckInProgram from './components/CheckInProgram/CheckInProgram';
import { clientProfilesEncrypted, clientRecordsInterface } from 'interfaces/Clients/clientsRecord';
import { useGetAccountPackageView } from 'utils/hooks/GetAccountInfo/accountPackageView';
import ClientStatusBadge from 'components/ClientStatusBadge/ClientStatusBadge';
import { useTranslation } from 'react-i18next';

interface ClientPersonalDetailsProps {
  clientRecordData: clientRecordsInterface;
  clientProfileData: clientProfilesEncrypted;
  onResendInvitation: () => void;
  onCancelInvitation: () => void;
  isInvitationProcessing: boolean;
}

const ClientPersonalDetails = ({ clientRecordData, clientProfileData }: ClientPersonalDetailsProps) => {
  const { isEdgeReceptionist } = useGetAccountPackageView();

  const [t] = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.profileBox}>
        <div className={styles.statusWrapper}>
          <div className={styles.subTitle}>{t('title.client_status').toUpperCase()}</div>
          <ClientStatusBadge recordStatus={clientRecordData.recordStatus} />
        </div>
      </div>

      <div className={styles.detailsBox}>
        <div className={styles.detailWrap}>
          <div className={styles.label}>{t('label.client_since')}:</div>
          <div className={styles.info}>{moment(clientRecordData.createdAt).format('DD MMM YYYY')}</div>
        </div>
        {clientRecordData.isCompleteRecords && !isEdgeReceptionist && (
          <CheckInProgram clientRecordId={clientRecordData._id} clientProfileId={clientProfileData._id} />
        )}
      </div>
    </div>
  );
};

export default ClientPersonalDetails;
